import Typography from 'components/atoms/Typography';
import { Kits } from 'utils/gloo-types';
import defaultKitBanner from 'assets/Kit_banner.png';
import Icon from 'components/atoms/Icon';
import { getVideoThumbnail, isVideo } from 'utils/discover';
import Markdown from 'components/atoms/Markdown';
import FavoriteButton from 'pages/_AdminAuthoringPages/_components/FavoriteButton';
import { isHexColorLight } from 'utils/common';
import PlayVideoButton from 'components/molecules/PlayVideoButton';

interface KitBannerProps {
  kit?: Kits;
}

function KitBannerPreview({ kit }: KitBannerProps) {
  const textColor: React.CSSProperties = kit?.branding?.textColor && {
    color: kit.branding.textColor,
  };
  const borderColor: React.CSSProperties = kit?.branding?.titleColor && {
    borderColor: kit.branding.titleColor,
  };
  const backgroundColor: React.CSSProperties = kit?.branding?.backgroundColor && {
    backgroundColor: kit.branding.backgroundColor,
  };
  const titleColor: React.CSSProperties = kit?.branding?.titleColor && {
    color: kit.branding.titleColor,
  };
  const buttonBackgroundColor: React.CSSProperties = {
    backgroundColor: kit?.branding?.titleColor ?? '#000',
    border: 0,
  };
  if (isHexColorLight(buttonBackgroundColor.backgroundColor)) {
    buttonBackgroundColor.color = '#000';
  }

  const backLinkStyle: React.CSSProperties = { ...textColor, display: 'none' };

  const bannerImageUrl = kit?.bannerImageUrl || defaultKitBanner;

  const hasVideoThumbnail = isVideo(bannerImageUrl);

  const thumbnail = hasVideoThumbnail ? getVideoThumbnail(bannerImageUrl) : bannerImageUrl;

  return (
    <div className="basis-1/2 md:block -m-6 py-5 px-5 bg-neutral-300 md:py-20" style={backgroundColor}>
      <div className="container mx-auto max-w-[985px]">
        <button
          type="button"
          data-durable-id="kitsBack"
          data-intercom-target="kitsBack"
          className="text-neutral-900 flex items-center pt-5 pl-5 pb-10 md:pt-10"
          style={backLinkStyle}
          onClick={undefined}
        >
          <Icon name="arrow-left" className="mr-5" />
          Back
        </button>
        <div className="flex flex-col lg:flex-row lg:items-start">
          <div className="p-5 lg:flex-3">
            <Typography variant="h2" style={titleColor}>
              {kit?.title}
            </Typography>
            <Typography variant="sm" className="mb-5" style={titleColor}>
              {kit?.subtitle}
            </Typography>
            {!!kit?.longDescription && (
              <span style={{ ...textColor, ...borderColor }}>
                <Markdown content={kit.longDescription} className="max-w-md md-render" defaultStyles={false} />
              </span>
            )}

            <div className="mt-5">
              <FavoriteButton
                favorited={false}
                text
                onUnfavorite={() => {}}
                onFavorite={() => {}}
                className="mr-4 my-2"
                style={buttonBackgroundColor}
              />
            </div>
          </div>

          <div className="p-5 lg:flex-2">
            <div className="relative">
              <img
                className="object-cover w-full rounded-lg"
                src={thumbnail}
                alt={`Kit ${kit?.title} thumbnail`}
                style={{ maxHeight: '400px' }}
              />
              {hasVideoThumbnail && <PlayVideoButton imageUrl={bannerImageUrl} />}
            </div>
            {(kit?.branding?.logoImageUrl || kit?.metadata?.author) && (
              <>
                <Typography variant="sm" className="my-5 text-center" style={textColor}>
                  This content provided by:
                </Typography>
                {kit?.branding?.logoImageUrl ? (
                  <img
                    style={{ maxHeight: '100px' }}
                    className="object-contain w-full"
                    src={kit?.branding.logoImageUrl}
                    alt={`${kit?.metadata?.author} logo`}
                  />
                ) : (
                  <div className="text-center" style={titleColor}>
                    {kit?.metadata?.author}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default KitBannerPreview;
